import { EnvironmentService, GapiService } from '../contracts';

export class AppGapiService implements GapiService {
  constructor(private readonly _environment: EnvironmentService) {}

  grantOfflineAccess(scopes: string[]): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      try {
        const client = google.accounts.oauth2.initCodeClient({
          client_id: this._environment.googleClientId,
          scope: scopes.join(' '),
          ux_mode: 'popup',
          select_account: true,
          error_callback: (error) => reject(error as Error),
          callback: (response) => {
            if (response.error_description) {
              reject(new Error(response.error_description));
            } else {
              resolve(response.code);
            }
          }
        });

        client.requestCode();
      } catch (error) {
        console.error('Failed to initialize Google API client:', error);
        if (error instanceof Error) {
          reject(error);
        } else {
          reject(
            new Error(typeof error === 'string' ? error : 'Unknown error during Google API client initialization')
          );
        }
      }
    });
  }
}
